export const initWebWorker = () => new Worker(new URL('../../workers/aws-web-worker.js', import.meta.url));
